module.exports = __webpack_public_path__ + "static/media/level1-1c.8cc2b654.mp3";